// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2024 (original work) Open Assessment Technologies SA;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

/**
 * Chains the guards to be used in the routing configuration
 * @param {Array<Function>} guards The guards to combine
 * @returns {Promise}
 */
export const multiGuard =
    (guards = []) =>
    async (next, router) => {
        for (const guard of guards) {
            let proceed = false;
            await guard(() => {
                proceed = true;
            }, router);
            if (!proceed) {
                return;
            }
        }
        return next();
    };
